var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPenLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 11.0827H3.73333L8.76458 6.05143L7.94792 5.23477L2.91667 10.266V11.0827ZM11.2583 5.2056L8.77917 2.7556L9.59583 1.93893C9.81944 1.71532 10.0941 1.60352 10.4198 1.60352C10.7455 1.60352 11.0201 1.71532 11.2438 1.93893L12.0604 2.7556C12.284 2.97921 12.4007 3.249 12.4104 3.56497C12.4201 3.88095 12.3132 4.15074 12.0896 4.37435L11.2583 5.2056ZM10.4125 6.06602L4.22917 12.2493H1.75V9.77018L7.93333 3.58685L10.4125 6.06602ZM8.35625 5.6431L7.94792 5.23477L8.76458 6.05143L8.35625 5.6431Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPenLight);
export default __webpack_public_path__ + "static/media/icon_pen_light.2a4fb8ff98c0c6ef67b41a8b6bad6f86.svg";
export { ForwardRef as ReactComponent };